// AppLayout tokens — shared across header, sidebar, and all pages

export const APP_COLORS = {
  ink: '#0E1A1A',
  inkSoft: '#2A3A3A',
  sub: '#5B6B6B',
  faint: '#9CA3AF',

  teal: '#15A08C',
  tealDark: '#0F8474',
  tealInk: '#0F6E56',
  tealSoft: '#E1F5EE',

  vela: '#6B46C1',
  velaSoft: '#F3EEFC',
  velaDark: '#553C9A',

  red: '#B53B2E',
  redSoft: '#FBEDEC',
  green: '#0D8050',
  greenSoft: '#E8F5F0',
  amber: '#B45309',
  amberSoft: '#FDF4E3',

  page: '#F4F6F8',
  card: '#FFFFFF',
  line: '#E7EAF0',
  lineSoft: '#EEF1F4',
  pillHover: '#F3F4F6',

  svcCircle: '#0F3E4F',
} as const;

export const APP_FONT = {
  family: 'Inter, system-ui, -apple-system, sans-serif',
  mono: 'ui-monospace, Menlo, monospace',
} as const;

export const APP_SIZES = {
  headerHeight: 60,
  sidebarWidth: 72,
  radiusCard: 14,
  radiusPill: 999,
  radiusButton: 10,
} as const;

export const APP_SHADOWS = {
  card: '0 1px 2px rgba(0,0,0,0.04)',
  elevated: '0 4px 14px rgba(0,0,0,0.08)',
  dropdown: '0 8px 24px rgba(0,0,0,0.12)',
} as const;
